module.exports = __webpack_public_path__ + "img/1 (44).e7e32c46.png";